//-------imports-----------
import React, { useState, useEffect } from "react";
import {
  Grid, Box,
  TextField,
  FormControl, Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
  Autocomplete
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { useLocation } from "react-router-dom";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { SETTINGS_API_08 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
const names = [
  { label: "Other", value: "O" },
];

const MapPrinters = () => {
  //----------------hooks---------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error1, setError1] = useState(null);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [dataitem, setDataitem] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [errors, setErrors] = useState({});
  const isEdit = location.state?.actionText === "Edit";
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    PRINTERNAME: "",
    PRINTERNICKNAME: "",
    PRINTERIP: "",
    MENUTYPECODE: "O",
    PRINTERCODE: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        PRINTERNAME: selectedItem.PRINTERNAME,
        PRINTERNICKNAME: selectedItem.PRINTERNICKNAME,
        PRINTERIP: selectedItem.PRINTERIP,
        PRINTERCODE: String(selectedItem.PRINTERCODE),
        MENUTYPECODE: selectedItem.MENUTYPECODE,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchData();
  }, []);

  //------------------function------------

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_08, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        MENUTYPECODE: CON_MENU_TYPE_CODE,
        STS: CON_STATUS_ACTIVE,
      });
      setDataitem(result);
    } catch (err) {
      setError(err);
    }
  };
  // handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };
  //postapi
  const handleConfirmClick = async () => {
    const { PRINTERIP, PRINTERNAME, PRINTERNICKNAME, MENUTYPECODE } =
      selectedItemDetails;

    const requiredFields = [
      { name: "MENUTYPECODE", value: MENUTYPECODE, label: "Item Type" },
      { name: "PRINTERIP", value: PRINTERIP, label: "Printer IP" },
      { name: "PRINTERNAME", value: PRINTERNAME, label: " Printer Name" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      setSnackbarMessage(errorMessage);
      setOpenErrorSnackbar(true);
      return;
    }

    if (dataitem) {
      const isDuplicate = dataitem.some((item) =>
          item.PRINTERCODE !== selectedItemDetails.PRINTERCODE &&
          item.PRINTERNAME.toLowerCase().trim() === PRINTERNAME.toLowerCase().trim()
       );

      if (isDuplicate) {
        setSnackbarMessage("Printer name already exists.");
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const printercode = selectedItem
      ? String(selectedItem.PRINTERCODE || "")
      : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      MENUTYPECODE: CON_MENU_TYPE_CODE,
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_08, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        PRINTERNAME: "",
        PRINTERNICKNAME: "",
        PRINTERIP: "",
        MENUTYPECODE: "",
        PRINTERCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/vmapprinter");
    }, 2000);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      PRINTERNAME: "",
      PRINTERNICKNAME: "",
      PRINTERIP: "",
      MENUTYPECODE: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const gotToView = () => {
    navigate("/vmapprinter");
  };
  //validations
  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError1("");
      handleInputChange(event);
    } else {
      setError1("Only numbers and floats are allowed.");
    }
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">{  isEdit ? "Edit Printer Mapping" : "Map Printers" }</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit Printer Mapping" : "Map Printers" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid container item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <FormControl size="small" fullWidth>
                <Autocomplete
                  options={names}
                  getOptionLabel={(option) => option.label}
                  value={
                    names.find(
                      (option) =>
                        option.value === selectedItemDetails.MENUTYPECODE
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "MENUTYPECODE",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Item Type
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      }
                      size="small"
                      fullWidth
                      variant="outlined"
                      error={Boolean(errors.MENUTYPECODE)}
                      helperText={errors.MENUTYPECODE}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label={
                  <span>
                    Printer Name
                    <span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="PRINTERNAME"
                value={selectedItemDetails.PRINTERNAME}
                onChange={handleInputChange}
                error={Boolean(errors.PRINTERNAME)}
                helperText={errors.PRINTERNAME}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <TextField
                label={
                  <span>
                    Printer IP<span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={selectedItemDetails.PRINTERIP}
                name="PRINTERIP"
                onChange={handleInputChange}
                error={Boolean(errors.PRINTERIP)}
                helperText={errors.PRINTERIP}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                label="Display Name"   
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="PRINTERNICKNAME"
                value={selectedItemDetails.PRINTERNICKNAME}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default MapPrinters;
